export default __webpack_public_path__ + "static/media/airplan1.c01579ff.jpg";